import { useUnit } from 'effector-react';
import $$giftTrust from 'models/gift-trusts';
import $$giftTrustPage from 'models/pages/gift-trust';
import { Button } from 'react-bootstrap';

import './GiftTrustDocumentsModal.scss';

import HText from 'components/HText';
import CommunityTab from 'components/StyledTemplates/CommunityTab';
import PopUpWrapper from 'components/StyledTemplates/PopUpWrapper';
import GiftTrustDocumentCard from 'components/pages/GiftTrustPage/GiftTrustDocumentCard';

import useModal from 'hooks/useModal';
import useResources from 'hooks/useResources';

import { Document } from 'types/zod/document';

const GiftTrustDocumentsModal = () => {
    const { state = {}, close } = useModal('GIFT_TRUST_DOCUMENTS_MODAL');

    const documents = useUnit($$giftTrust.$documents);
    const documentsForQInstance = documents?.[state.qInstanceId] || [];

    const giftTrustDocs = (documentsForQInstance || []).filter((doc: Document) => doc.category_code === 'gift_trust');
    const supportDocs = (documentsForQInstance || []).filter(
        (doc: Document) => doc.category_code === 'gift_trust_supporting',
    );

    const { t } = useResources();

    return (
        <PopUpWrapper name="GIFT_TRUST_DOCUMENTS_MODAL" whiteCross size="lg">
            <CommunityTab title={t('giftTrustPage.giftTrustDocumentsModal.title')} extraBody="align-items: flex-start;">
                <div className="gift-trust-documents-modal">
                    <div className="documents-header">
                        <div>{t('giftTrustPage.giftTrustDocumentsModal.giftTrustDocuments')}</div>
                        <div
                            className="download-all-link"
                            onClick={() => $$giftTrustPage.downloadAllButtonClicked(state.qInstanceId)}
                        >
                            {t('giftTrustPage.giftTrustDocumentsModal.downloadAll')}
                        </div>
                    </div>
                    <div className="documents-description">
                        <HText>{t('giftTrustPage.giftTrustDocumentsModal.description')}</HText>
                    </div>
                    {giftTrustDocs.map((doc: Document) => {
                        return <GiftTrustDocumentCard key={doc.document_id} document={doc} />;
                    })}

                    <div className="delimiter" />

                    <div className="documents-header">
                        {t('giftTrustPage.giftTrustDocumentsModal.supportDocuments')}
                    </div>
                    {supportDocs.map((doc: Document) => {
                        return <GiftTrustDocumentCard key={doc.document_id} document={doc} />;
                    })}

                    <div className="delimiter" />

                    <div className="w-100 d-flex justify-content-end">
                        <Button
                            data-qaid="close_button"
                            className="btn btn-secondary pl-0 pr-2 pl-sm-2"
                            onClick={close}
                        >
                            {t('giftTrustPage.giftTrustDocumentsModal.close')}
                        </Button>
                    </div>
                </div>
            </CommunityTab>
        </PopUpWrapper>
    );
};

export default GiftTrustDocumentsModal;
